<!---
   <div class="div-holder" style="width: 58%; float:left;align-content:flex-start;padding-left:0px;">
  -->
<!----
   <div style="column-gap:0px;align-content:start;text-align:right;padding-left:2px;width:60%;float:left;">
  <div class="alert alert-danger" style="margin-left:140px;width: 350px !important;" *ngIf="invalidLogin">
  Username or Password is incorrect.
</div>
  -->

<div *ngIf="showLogin">
 

    <div class="row=" style="display:flex;">
     
        <div class="container divclass">


        </div>
  
      
        <div class="column">


          <div class="row">

            <div class="column" style=" justify-content: left;align-items: center;">
              <div class="alert alert-danger  mt-3 mb-0" style="margin-left:140px;width: 350px !important;" *ngIf="invalidLogin">
                Username or Password is incorrect.
              </div>

              <div *ngIf="alreadyLogged" class="alert alert-danger mt-3 mb-0" style="margin-left:140px;width: 350px !important;">
                This User Already Logged In.
              </div>

              <div class="card bg-light border-dark mb-3" style="color:black;width:400px;margin-left:140px;margin-top:0px;border-radius: 25px;">
                <h5 class="card-header" style="background-color: #2D7C8E; color: white; text-align: left; border-radius: 25px;">Login to LMS</h5>
                <div class="card-body">
                  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <mat-form-field appearance="fill" [style.width.px]=340>
                            <mat-icon matPrefix class="my-icon" style="color:limegreen;"> email</mat-icon>
                            <input type="text" matInput formControlName="userName" tabindex="1" autofocus [ngClass]="{ 'is-invalid': submitted && loginForm.get('userName')?.errors }"
                                   placeholder="Type Email Id" />
                                                                                            


                        </mat-form-field>
                      <div *ngIf="submitted && loginForm.get('userName')?.errors" class="invalid-feedback">

                          <div *ngIf="loginForm.get('username')?.errors?.['required']">Username is required</div>
                      </div>
                    </div>

                    <div class="form-group">
                      <mat-form-field appearance="fill" [style.width.px]=340>

                        <mat-icon matPrefix class="my-icon" style="color:limegreen;"> password</mat-icon>
                        <input type="password" matInput formControlName="password" tabindex="2" style="width:250px"
                               [ngClass]="{ 'is-invalid': submitted && loginForm.get('password')?.errors }" placeholder="Type Password" />
                      </mat-form-field>
                      <div *ngIf="submitted && loginForm.get('password')?.errors" class="invalid-feedback">
                        <div *ngIf="loginForm.get('password')?.errors?.['required']">Password is required</div>
                      </div>
                    </div>
                    <button [disabled]="loading" class="my-button">
                      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      Login
                    </button>
                  </form>
                </div>
              </div>


            </div>

          </div>

          <div class="row" style="margin-left: 140px; display: inline-block;">
            <a [routerLink]="'/forgotpass'" class="col-sm-2">Forgot Password...?</a>

          </div>

          <!---
    <div *ngIf="loginForm.errors?.invalidLogin" class="alert alert-danger mt-3 mb-0">
    Username or Password is incorrect.
  </div>
    -->
          <!---
   </div>

  -->
          <!---
   <div class="col-auto divclass div-holder" style="width:38%;column-gap:0px;align-content:start;text-align:right;padding-left:30px;">

  -->


        </div>

    </div>
  
  </div>





